import React from "react";
import { Box } from "@mui/material";
import { FaWhatsapp } from "react-icons/fa";

// Social media logos data (you can customize this)
const socialLogos = [
  {
    name: "WhatsApp",
    url: "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
  },
  {
    name: "Facebook",
    url: "https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
  },
  {
    name: "Twitter",
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/X_logo_2023_original.svg/1280px-X_logo_2023_original.svg.png",
  },

  {
    name: "Instagram",
    url: "https://upload.wikimedia.org/wikipedia/commons/e/e7/Instagram_logo_2016.svg",
  },
];

const SocialContainer = ({
  children,
  background = "linear-gradient(120deg, #f5f7fa 0%, #c3cfe2 100%)",
  socialIcons = socialLogos,
  showWhatsAppIcons = true,
  minHeight = "100vh",
  ...props
}) => {
  return (
    <Box
      sx={{
        minHeight,
        background,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 4,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundSize: "200px, 150px, 120px, 180px",
          backgroundPosition: "10% 15%, 85% 25%, 30% 70%, 70% 60%",
          backgroundRepeat: "repeat",
          zIndex: 0,
        },
        ...props.sx,
      }}
      {...props}
    >
      {/* Floating Social Media Logos */}
      {socialIcons.map((logo, index) => (
        <Box
          key={logo.name}
          sx={{
            position: "absolute",
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.8)",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 0,
            animation: `float 2s ease-in-out ${index * 2}s infinite`,
            "@keyframes float": {
              "0%": {
                transform: "translateY(0px) rotate(0deg)",
              },
              "50%": {
                transform: `translateY(-20px) rotate(${
                  index % 2 ? 10 : -10
                }deg)`,
              },
              "100%": {
                transform: "translateY(0px) rotate(0deg)",
              },
            },
            // Position each logo differently
            ...(index === 0 && {
              top: "15%",
              left: "8%",
            }),
            ...(index === 1 && {
              top: "25%",
              right: "10%",
            }),
            ...(index === 2 && {
              bottom: "20%",
              left: "12%",
            }),
            ...(index === 3 && {
              bottom: "15%",
              right: "8%",
            }),
          }}
        >
          <img
            src={logo.url}
            alt={logo.name}
            style={{
              width: "60%",
              height: "60%",
              objectFit: "contain",
            }}
          />
        </Box>
      ))}

      {/* WhatsApp Icon Decorations */}
      {showWhatsAppIcons && (
        <>
          <Box
            sx={{
              position: "absolute",
              top: "10%",
              left: "5%",
              fontSize: "5rem",
              color: "#25D366",
              opacity: 0.1,
              transform: "rotate(-15deg)",
              zIndex: 0,
            }}
          >
            <FaWhatsapp />
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: "15%",
              right: "7%",
              fontSize: "4rem",
              color: "#1976d2",
              opacity: 0.1,
              transform: "rotate(15deg)",
              zIndex: 0,
            }}
          >
            <FaWhatsapp />
          </Box>
        </>
      )}

      {/* Tech Pattern Overlay */}
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          background: `
            radial-gradient(circle at 15% 50%, rgba(37, 211, 102, 0.1) 0%, transparent 20%),
            radial-gradient(circle at 85% 30%, rgba(25, 118, 210, 0.1) 0%, transparent 20%),
            radial-gradient(circle at 50% 80%, rgba(66, 133, 244, 0.1) 0%, transparent 20%)
          `,
          zIndex: 0,
        }}
      />

      {/* Content */}
      <Box sx={{ position: "relative", zIndex: 1, width: "100%" }}>
        {children}
      </Box>
    </Box>
  );
};

export default SocialContainer;
